import { useEffect, useState } from "react";
import { Link, NavLink, Outlet, Route, Routes, useLocation, } from "react-router-dom";
import { useApi } from "../../context/ApiProvider";
import NoAccess from "../NoAccess";
import Client from "./Client";
import Administrators from "./Administrators";
import ExportOwners from "./ExportOwners";
import { Field, Form, Formik } from "formik";
import Administrator from "./Administrator";
import PushNotifications from "./PushNotification";
import Card from "../Helpers/Card";
import StatisticsOverview from "./statistics/StatisticsOverview";
import Billing from "./billing/Billing";
import BillingV2 from "./billingV2/BillingV2";
import Partners from "./Partners";
import Partner from "./Partner";
import Retention from "./Retention";
import ActivityIndicator from "../Helpers/ActivityIndicator";
import TemplateLibrary from "./TemplateLibrary";

export default function RolfAdmin() {

  return (
    <>
      <Routes>
        <Route path="/*" element={<Layout />}>
          <Route index element={<ListClients />} />
          <Route path="administrators/*" >
            <Route index element={<Administrators />} />
            <Route path=":administratorId" element={<Administrator />} />
          </Route>
          <Route path="partners/*" >
            <Route index element={<Partners />} />
            <Route path=":partnerId" element={<Partner />} />
          </Route>
          <Route path="billing/*" element={<Billing />} />
          <Route path="billing-v2/*" element={<BillingV2 />} />
          <Route path="clients/*" >
            <Route path=":clientId/*" element={<Client />} />
          </Route>
          <Route path="pushnotifications/*" element={<PushNotifications />} />
          <Route path="exportowners/*" element={<ExportOwners />} />
          <Route path="retention/*" element={<Retention />} />
          <Route path="templatelibrary/*" element={<TemplateLibrary />} />
          <Route path="statistics/*" element={<StatisticsOverview />} />
        </Route>
      </Routes>
    </>
  )
}

const Layout = () => {

  // extract pathname from location
  const { pathname } = useLocation();

  return (
    <>
      <h2>Rolf administration</h2>
      <nav>
        <ul className="nav">
          <li>
            <NavLink to="" end className={({ isActive }) =>
              isActive || pathname.includes("clients") ? 'active' : undefined
            }>Clients</NavLink>
          </li>
          <li>
            <NavLink to="administrators" end className={
              () => pathname.includes("administrators") ? "active" : undefined
            }>Administrators</NavLink>
          </li>
          <li>
            <NavLink to="partners" end className={
              () => pathname.includes("partners") ? "active" : undefined
            }>Partners</NavLink>
          </li>
          <li>
            <NavLink to="billing/createinvoices" end className={
              () => pathname.includes("billing/") ? "active" : undefined
            }>Billing overview</NavLink>
          </li>
          <li>
            <NavLink to="billing-v2" end className={
              () => pathname.includes("billing-v2") ? "active" : undefined
            }>Fakturering 2</NavLink>
          </li>
          <li>
            <NavLink to="pushnotifications" end className={
              () => pathname.includes("pushnotifications") ? "active" : undefined
            }>Push notifications</NavLink>
          </li>
          <li>
            <NavLink to="exportowners" end className={({ isActive }) =>
              isActive ? 'active' : undefined
            }>Export groupleaders</NavLink>
          </li>
          <li>
            <NavLink to="retention" end className={({ isActive }) =>
              isActive ? 'active' : undefined
            }>Data retention</NavLink>
          </li>
          <li>
            <NavLink to="templatelibrary" end className={
              () => pathname.includes("templatelibrary") ? "active" : undefined
            }>Template library</NavLink>
          </li>
          <li>
            <NavLink to="statistics" end className={
              () => pathname.includes("statistics") ? "active" : undefined
            }>Statistics</NavLink>
          </li>
        </ul>
      </nav>
      <Outlet />
    </>
  )
}


function ListClients() {

  const Api = useApi();
  const [clients, setClients] = useState([]);
  const [hasPermission, setHasPermission] = useState();
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const [search, setSearch] = useState('');
  const [createClientSucces, setCreateClientSuccess] = useState(false);
  const [createClientError, setCreateClientError] = useState(false);
  const [filter, setFilter] = useState({ paying: true, nonpaying: true, active: true, inactive: true })
  const [sort, setSort] = useState({ field: '', order: 'asc' }); //För att kunna sortera tabellen

  useEffect(() => {
    fetchClients();
  }, []);

  useEffect(() => {

    if (!clients || clients.length === 0)
      return;

    const field = sort.field;

    const sortedClients = [...clients].sort((a, b) => {
      if (field === 'name') {
        if (a[field].toLowerCase() < b[field].toLowerCase())
          return sort.order === 'asc' ? -1 : 1;
        if (a[field].toLowerCase() > b[field].toLowerCase())
          return sort.order === 'asc' ? 1 : -1;
        return 0;
      }

      if (field === 'paying' || field === 'active') {
        if (a[field] === 0 && b[field] === 1)
          return sort.order === 'asc' ? 1 : -1;
        if (a[field] === 1 && b[field] === 0)
          return sort.order === 'asc' ? -1 : 1;
        return 0;
      }

      if (a[field] < b[field])
        return sort.order === 'asc' ? -1 : 1;
      if (a[field] > b[field])
        return sort.order === 'asc' ? 1 : -1;
      return 0;
    });
    setClients(sortedClients);
  }, [sort]);

  const fetchClients = async () => {
    setIsLoadingClients(true);
    Api.get("/rolf/clients").then(data => {
      setClients(data);
      setHasPermission(true);
    }).catch(error => {
      if (error.status === 403) {
        setHasPermission(false);
      }
    }).finally(() => {
      setSort({ field: '', order: 'asc' }); //Nollställer sorteringen
      setIsLoadingClients(false);
    });
  }

  const sortClients = (field) => {
    setSort((prev) => ({ field, order: prev.field === field ? prev.order === 'asc' ? 'desc' : 'asc' : 'asc' }));
  }

  const resetSort = () => {
    fetchClients();
  }

  const searchCallback = (client) => {

    if (!filter.paying && client.paying)
      return false;

    if (!filter.nonpaying && !client.paying)
      return false;

    if (!filter.active && client.active)
      return false;

    if (!filter.inactive && !client.active)
      return false;

    if (search === '')
      return true;

    const searchValue = search.toLowerCase();

    if (client.name.toLowerCase().includes(searchValue))
      return true;
  }

  if (!isLoadingClients && !hasPermission)
    return <NoAccess />

  return (
    <div className="grid-container">
      <>
        <section className="grow">
          <h3>List of clients</h3>
          <label>Search client</label><input type="search" placeholder="Search client by name" size={30} onChange={(e) => { setSearch(e.target.value) }} className="formControl" />
          <input type="checkbox" checked={filter.paying} onChange={(e) => { setFilter({ ...filter, paying: e.target.checked }) }} /> Paying clients
          <input type="checkbox" checked={filter.nonpaying} onChange={(e) => { setFilter({ ...filter, nonpaying: e.target.checked }) }} /> Non-paying clients
          <input type="checkbox" checked={filter.active} onChange={(e) => { setFilter({ ...filter, active: e.target.checked }) }} /> Active clients
          <input type="checkbox" checked={filter.inactive} onChange={(e) => { setFilter({ ...filter, inactive: e.target.checked }) }} /> Inactive clients

          <p className="meta">Click headers to toggle sort order <a onClick={resetSort}>Reset sort</a></p>
          {isLoadingClients && <ActivityIndicator color={'black'}/>}
          
          <table>
            <thead>
              <tr>
                <th onClick={() => sortClients("name")} title="Name of the client. Click the name to administer.">Client {sort.field === 'name' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
                <th onClick={() => sortClients("paying")} title="Whether the client is a paying customer or not.">Paying {sort.field === 'paying' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
                <th onClick={() => sortClients("active")} title="Whether the client is active or not.">Active {sort.field === 'active' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
                <th title="Which modules the client has access to.">Modules</th>
                <th onClick={() => sortClients("members")} title="Number of members the client has.">Members {sort.field === 'members' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
                <th onClick={() => sortClients("administrators")} title="Number of administrators connected to the client.">Administrators {sort.field === 'administrators' ? sort.order === 'asc' ? '▲' : '▼' : null}</th>
              </tr>
            </thead>
            <tbody>
              {clients && clients.filter(searchCallback).map(function (client, index) {
                return (
                  <tr key={index}>
                    <td><Link to={`/rolf/clients/${client.ID}`} className={client.active === 0 ? 'inactive' : ''}>{client.name || "No name"}</Link></td>
                    <td>{client.paying ? 'Yes' : 'No'}</td>
                    <td>{client.active ? 'Yes' : 'No'}</td>
                    <td>{client.modules}</td>
                    <td>{client.members}</td>
                    <td>{client.administrators}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </section>
        <section>
          <h3>Create a new client</h3>
          <Card>
            <Formik
              initialValues={{ name: '' }}
              onSubmit={async (values, { setSubmitting, resetForm }) => {
                if (!values.name || values.name.length < 3) {
                  alert('Please enter a valid client name (at least 3 characters)');
                  return;
                }
                setSubmitting(true);
                Api.post("/rolf/clients", values).then(result => {
                  resetForm();
                  fetchClients();
                  setCreateClientSuccess('Client created successfully');

                }).catch(e => {
                  setCreateClientError(e.error);
                }).finally(() => {
                  setSubmitting(false);
                  setTimeout(() => {
                    setCreateClientSuccess(false);
                    setCreateClientError(false);
                  }, 3000)
                });
              }}>
              {({ isSubmitting }) => (
                <Form>
                  {createClientError && <div className="formControlError">{createClientError}</div>}
                  {createClientSucces && <div className="formControlSuccess">{createClientSucces}</div>}
                  <label htmlFor="name">Client name:</label><br />

                  <Field type="text" name="name" id="name" placeholder="Name of the client" className="formControl" />


                  <button type="submit" disabled={isSubmitting}>Create client</button>
                </Form>
              )}
            </Formik>
          </Card>
        </section>
      </>
    </div>
  )
}
